import classNames from 'classnames';
import React, { useState } from 'react';
import IconButton from '../components/IconButton';
import OverflowMenu from '../components/OverflowMenu';
import SVGIcon from '../components/SVGIcon';
import overflowMenuIcon from '../icons/non-prefilled/16x16/overflowMenu.svg';
import styles from './PostStateBarOverflowMenu.module.scss';

interface PostStateBarOverflowMenuProps {
  variant?: 'success' | 'muted' | 'warning';
  children: React.ReactNode;
}

const PostStateBarOverflowMenu = ({
  variant,
  children,
}: PostStateBarOverflowMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <OverflowMenu
      onOpenChange={setIsOpen}
      open={isOpen}
      button={
        <IconButton
          className={classNames(
            styles.button,
            { [styles.isOpen]: isOpen },
            variant ? styles[variant] : null,
          )}
          active={isOpen}
          aria-label="Options"
        >
          <SVGIcon>{overflowMenuIcon}</SVGIcon>
        </IconButton>
      }
    >
      {children}
    </OverflowMenu>
  );
};

export default PostStateBarOverflowMenu;
